import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import type { UpsertRtiTemplateApiResponse, UpsertRtiTemplateBody } from 'model/interfaces/rti-template';

const RTI_UPSERT_TEMPLATE_PATH = 'rti/upsertrtitemplate';

export const upsertRtiTemplate = async (
  templateVersion: number,
  body: UpsertRtiTemplateBody,
): Promise<UpsertRtiTemplateApiResponse> => {
  const res = await kf1AuthenticatedHttpClient({
    baseURL: ENV_VARS.API_URL,
    url: RTI_UPSERT_TEMPLATE_PATH,
    method: 'PUT',
    params: { templateVersion },
    data: body,
  });
  return res.data as UpsertRtiTemplateApiResponse;
};
